import { format, parse } from 'date-fns';

export const formatDate = (standardDateStr, targetPattern) =>
  format(
    parse(standardDateStr.split('T')[0], 'yyyy-MM-dd', new Date()),
    targetPattern
  );
